// LIBRARIES
import styled from "styled-components";
import { FormControl } from "@material-ui/core";
import { Select } from "@mui/material";
import TextField from "@mui/material/TextField";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const SelectAtomContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const LabelContainer = styled.div`
  font-size: 16px;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 7px;
  font-weight: medium;
  font-family: ${FONTS.montserrat};
`;
export const FormControlContainer = styled(FormControl)`
  &.MuiFormControl-root {
    margin-left: 16px;
    border-radius: 16px;
    background: ${COLORS.backgroundColor};
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${COLORS.cornflowerBlue};
  }
`;

export const SelectContainer = styled(Select)`
  && {
    height: 40px;
    padding-left: 10px;
    margin-right: 10px;
    padding-right: 20px;
    color: ${(props) => (props.selectedOptions ? "#293462" : "#B6B7BF")};
    font-weight: medium;
  }

  .MuiSelect-icon {
      width: 9px;
      top: 10px !important;
      transform: rotate(90deg) !important;
  }
  
  .MuiSelect-iconOpen {
      width: 9px;
      top: 10px !important;
      transform: rotate(270deg) !important;
  }
  
  .MuiInputBase-root {
    &:after {
      border-bottom: none;
    }

    &.Mui-focused {
      &:after {
        border-bottom: none;
      }
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
    border-radius: 16px; // Apply border-radius here
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
    border-radius: 16px; // Ensure border-radius here too for focus state
    outline: none;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border: none;
    border-radius: 16px; // Ensure border-radius here for hover state
  }

  .MuiOutlinedInput-input {
    border-radius: 16px; // Apply border-radius to the input itself
  }
`;

export const TextFieldContainer = styled(TextField)``;
